import { firebaseDb, ServerTimestamp } from '../firebase/'
import history from '../history'
import { addNotification } from './notification'

export const initUser = user => (
  dispatch => {
    firebaseDb.collection('users').doc(user.uid).set({
      uid: user.uid,
      realName: user.displayName,
      updated: ServerTimestamp
    })
    .then(() => {
      dispatch(connectSlack(user))
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("初期化に失敗しました", "error"))
    })
  }
)
export const updateUserInfo = values => (
  dispatch => {
    firebaseDb.collection('users').doc(values.uid).update({
      realName: values.realName,
      nickName: values.nickName,
      position: values.position,
      introduction: values.introduction,
      updated: ServerTimestamp
    })
    .then(() => {
      dispatch(addNotification("更新しました", "success"))
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("更新に失敗しました", "error"))
    })
  }
)

export const connectSlack = user => (
  dispatch => {
    firebaseDb.collection('config').doc('slack').get()
    .then(doc => {
      if (doc.exists) {
        dispatch(fetchSlackData(user, doc.data().token))
      } else {
        dispatch(addNotification("Slackトークンを設定してください", "error"))
      }
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("Slackトークンの取得に失敗しました", "error"))
    })
  }
)
const fetchSlackData = (user, token) => (
  dispatch => {
    const apiEndpoint = 'https://slack.com/api/users.list?token=' + token
    let memberExists = false
    fetch(apiEndpoint).then(response => {
      return response.json()
    }).then(json => {
      if(json.members){
        json.members.forEach(member => {
          if(member.profile.email === user.email){
            memberExists = true
            dispatch( updateUserSlackData({
              id: member.id,
              name: member.profile.display_name? member.profile.display_name : member.profile.real_name,
              images: {
                original: member.profile.image_original,
                x24: member.profile.image_24,
                x32: member.profile.image_32,
                x48: member.profile.image_48,
                x72: member.profile.image_72,
                x192: member.profile.image_192
              }
            }, user))
          }
        })
        if(!memberExists){
          dispatch(addNotification("Slackにユーザーが登録されていません", "error"))
        }
      }else{
        dispatch(addNotification("Slackデータの取得に失敗しました", "error"))
      }
    })
  }
)
const updateUserSlackData = (values, user) => (
  dispatch => {
    firebaseDb.collection('users').doc(user.uid).update({
      slackId: values.id,
      slackName: values.name,
      images: values.images,
      updated: ServerTimestamp
    })
    .then(() => {
      dispatch(addNotification("Slackと同期しました", "success"))
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("Slackデータの更新に失敗しました", "error"))
    })
  }
)

export const loadUserInfo = user => (
  dispatch => {
    firebaseDb.collection('users').doc(user.uid).onSnapshot(doc => {
      if (doc.exists) {
        dispatch({
          type: 'LOAD_USER_INFO',
          payload: doc.data()
        })
      } else {
        dispatch(initUser(user))
        history.push('/setting')
        dispatch(addNotification("ユーザー情報を入力してください", "warning"))
      }
    }, err => {
      console.log("Error getting document:", err)
    })
  }
)


// WEBPACK FOOTER //
// ./src/actions/setting.js